<script>
  export let data;
</script>

<div class="p-4 mx-auto">
  <div class="space-y-3 max-w-2xl mx-auto">
    <!-- UDI Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center"></div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Product Name</div>
        <div class="text-sm font-semibold text-gray-900">{data.name}</div>
        <div class="text-xs text-gray-600 mt-1 mb-0">Product Version</div>
        <div class="text-sm font-semibold text-gray-900">{data.version}</div>
      </div>
    </div>

    <!-- UDI Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/UDI.svg" alt="UDI" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Device Identifier</div>
        <div class="text-sm font-semibold text-gray-900">{data.serialNumber}</div>
        <div class="text-xs text-gray-600 mt-1 mb-0">Production Identifier</div>
        <div class="text-sm font-semibold text-gray-900">{data.productionId}</div>
      </div>
    </div>
    
    <!-- Release Date (no symbol) -->
    {#if data.releaseDate}
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <!-- No symbol for release date -->
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Release Date</div>
        <div class="text-sm font-semibold text-gray-900">{data.releaseDate}</div>
      </div>
    </div>
    {/if}
    
    <!-- REF Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/REF.svg" alt="REF" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Reference Number</div>
        <div class="text-sm font-semibold text-gray-900">{data.refNumber}</div>
      </div>
    </div>
    
    <!-- Consult Instructions Symbol -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/Info.svg" alt="Consult Instructions" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Instructions for Use</div>
        <div class="text-sm font-semibold text-gray-900">{data.instructionsUrl}</div>
      </div>
    </div>
    
    <!-- Manufacturer Symbol (Solid factory building) -->
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        <img src="/regulatory/Factory-Filled.svg" alt="Manufacturer" class="w-8 h-8" />
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Manufacturer</div>
        <div class="text-sm font-semibold text-gray-900">{data.manufacturer.name}</div>
        <div class="text-sm text-gray-900 mt-0">{data.manufacturer.address1}</div>
        <div class="text-sm text-gray-900 mt-0">{data.manufacturer.address2}</div>
      </div>
    </div>

    <!-- Customer Service -->
    {#if data.customerServiceUrl}
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 w-8 h-8 flex items-center justify-center">
        
      </div>
      <div class="flex-1">
        <div class="text-xs text-gray-600 mb-0">Customer Service</div>
        <div class="text-sm font-semibold text-gray-900">{data.customerServiceUrl}</div>
      </div>
    </div>
    {/if}
  </div>
</div>

